var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfopop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5505 0.98938L57.6624 2.27418C59.6834 2.59428 61.6415 3.2305 63.4647 4.15948L70.7826 7.88811C72.6058 8.81709 74.2714 10.0272 75.7184 11.4742L81.5258 17.2816C82.9728 18.7286 84.1829 20.3942 85.1119 22.2174L88.8405 29.5353C89.7695 31.3585 90.4057 33.3166 90.7258 35.3376L92.0106 43.4495C92.3307 45.4706 92.3307 47.5294 92.0106 49.5505L90.7258 57.6624C90.4057 59.6834 89.7695 61.6415 88.8405 63.4647L85.1119 70.7826C84.1829 72.6058 82.9728 74.2714 81.5258 75.7184L75.7184 81.5258C74.2714 82.9728 72.6058 84.1829 70.7826 85.1119L63.4647 88.8405C61.6415 89.7695 59.6834 90.4057 57.6624 90.7258L49.5505 92.0106C47.5294 92.3307 45.4706 92.3307 43.4495 92.0106L35.3376 90.7258C33.3166 90.4057 31.3585 89.7695 29.5353 88.8405L22.2174 85.1119C20.3942 84.1829 18.7286 82.9728 17.2816 81.5258L11.4742 75.7184C10.0272 74.2714 8.81709 72.6058 7.88811 70.7826L4.15948 63.4647C3.2305 61.6415 2.59428 59.6834 2.27418 57.6624L0.98938 49.5505C0.669277 47.5294 0.669277 45.4706 0.98938 43.4495L2.27418 35.3376C2.59428 33.3166 3.2305 31.3585 4.15948 29.5353L7.88811 22.2174C8.81709 20.3942 10.0272 18.7286 11.4742 17.2816L17.2816 11.4742C18.7286 10.0272 20.3942 8.81709 22.2174 7.88811L29.5353 4.15948C31.3585 3.2305 33.3166 2.59428 35.3376 2.27418L43.4495 0.98938C45.4706 0.669277 47.5294 0.669277 49.5505 0.98938Z",
    fill: "#E3E9EC",
    stroke: "#AABDC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9062 43.3438H47.4062V60.8125",
    stroke: "#00525D",
    strokeWidth: 4.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9922 61.2188H54.0078",
    stroke: "#00525D",
    strokeWidth: 4.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 37.25C46.3572 37.25 45.7289 37.0594 45.1944 36.7023C44.6599 36.3452 44.2434 35.8376 43.9974 35.2437C43.7514 34.6499 43.687 33.9964 43.8124 33.366C43.9379 32.7355 44.2474 32.1564 44.7019 31.7019C45.1564 31.2474 45.7355 30.9379 46.366 30.8124C46.9964 30.687 47.6499 30.7514 48.2437 30.9974C48.8376 31.2434 49.3452 31.6599 49.7023 32.1944C50.0594 32.7289 50.25 33.3572 50.25 34C50.25 34.862 49.9076 35.6886 49.2981 36.2981C48.6886 36.9076 47.862 37.25 47 37.25Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfopop);
export default __webpack_public_path__ + "static/media/infopop.5aa8cba4196d74937d33b73fff25ea8a.svg";
export { ForwardRef as ReactComponent };